import React from 'react';
import { CompanyLogo } from '@/Components/shared';
import { Card } from '@/Components/shadcn';
import UIStrings from '@/Utils/UIStrings';
import EmailVerifiedPageContent from './Components/EmailVerifiedPageContent';
import MeshBackgroundCenterOverlay from '@/Components/layouts/MeshBackroundCenterOverlay';

function EmailVerified(): React.JSX.Element {
    return (
        <MeshBackgroundCenterOverlay>
            <CompanyLogo
                width={195}
                height={37.5}
                color="primary"
                className="mb-8"
                aria-label={UIStrings.CompanyLogo}
            />
            <Card className="border-border w-full overflow-hidden border p-4 drop-shadow-xl">
                <EmailVerifiedPageContent />
            </Card>
        </MeshBackgroundCenterOverlay>
    );
}

export default EmailVerified;
